import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable vue/no-mutating-props */
/* eslint-disable max-lines */
import _ from 'lodash';
import { customerTypeList, platformList, categoryList, channelTypeList, typeList, advertiserAuditList, sourceList, businessTypeList, projectTypeList, serviceAttribution, serviceType, bigMediaCreativeTypeList, interactiveMaterialTypeList, noninteractiveSecondaryLevelTagList, noninteractiveThirdLevelTagList, caseAuthTypeList, contentRatingList, reportPointList, creativeGenreList, bizScenario, gradeList } from '@/common/demand';
import { interactiveCreationTypeList, nonInteractiveCreationTypeList } from '@/views/demand/utils/creation';
import Uploader from './uploader.vue';
import ProductInfo from './product.vue';
import CreationList from './creation-list.vue';
import SaveDemand from './save-demand.vue';
import RadioGroupFormItem from './radio-group-form-item.vue';
import SelectorFormItem from '../components/selector-form-item.vue';
import { generateProduct } from '@/views/demand/utils/product';
import AdvertiserSelector from '@/components/AllAdvertiserSelector/index.vue';
import DemandSelector from '@/components/DemandSelector/index.vue';
import AccountMgrSelector from '@/components/AccountMgrSelector/index.vue';
import Invoice from '../components/invoice.vue';
import SettlementInfo from './settlement.vue';
import demandMixin from './demand-mixin';
import settlementFormItemMixin from './settlement-form-item-mixin';
import { fellAllAdvertisers } from '@/api/demand/demand';

export default {
  mixins: [demandMixin, settlementFormItemMixin],

  components: {
    ProductInfo: ProductInfo,
    RadioGroupFormItem: RadioGroupFormItem,
    CreationList: CreationList,
    SaveDemand: SaveDemand,
    Uploader: Uploader,
    AdvertiserSelector: AdvertiserSelector,
    DemandSelector: DemandSelector,
    AccountMgrSelector: AccountMgrSelector,
    Invoice: Invoice,
    SettlementInfo: SettlementInfo,
    SelectorFormItem: SelectorFormItem
  },

  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    urlReviewId: {
      type: [String, Number],
      default: ''
    },
    demand: {
      type: Object,
      required: true
    },
    creationList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    updateDemand: {
      type: Function,
      default: function _default() {}
    },
    updateProducts: {
      type: Function,
      default: function _default() {}
    },
    emptyCreationList: {
      type: Function,
      default: function _default() {}
    },
    updateCreationList: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '150px'
      },

      currentAdvertiserHasInvoices: false,

      advertiserList: null
    };
  },


  computed: {
    review_id: function review_id() {
      return this.demand.review_id || '';
    },
    formItemList: function formItemList() {
      var _this = this;

      return _extends({
        name: {
          label: '需求名称',
          prop: 'name',
          rules: [{
            required: true,
            message: '请输入需求名称',
            trigger: 'blur'
          }, {
            min: 1,
            max: 500,
            message: '需求名称不能超过 500 个字符',
            trigger: 'blur'
          }],
          params: {
            disabled: this.isFromSS,
            type: 'text',
            clearable: true,
            placeholder: '建议以“产品名称+需求归属”命名'
          }
        },
        instruction: {
          label: '需求说明',
          prop: 'instruction',
          rules: [{
            required: true,
            message: '请输入需求说明',
            trigger: 'blur'
          }, {
            min: 1,
            max: 2000,
            message: '需求说明不能超过 2000 个字符',
            trigger: 'blur'
          }],
          params: {
            disabled: this.isFromSS,
            type: 'textarea',
            autosize: { minRows: 2, maxRows: 10 },
            clearable: true,
            placeholder: '建议按照创意方向提需求，一个创意方向对一个需求'
          }
        },
        reference_url: {
          label: '创意参考资料',
          prop: 'reference_url'
        },
        category: {
          label: '需求归属',
          prop: 'category',
          rules: [{
            required: true,
            message: '请选择项目背景',
            trigger: 'blur'
          }],
          params: {
            disabled: this.isFromSS,
            options: categoryList,
            clearable: true,
            placeholder: '请选择项目背景'
          }
        },
        expect_time: {
          label: '期望交付日期',
          prop: 'expect_time',
          rules: [{
            required: true,
            message: '请选择期望交付的日期',
            trigger: 'change'
          }],
          params: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            placeholder: '请选择期望交付的日期',
            clearable: true
          }
        },
        order_time: {
          visible: this.isDesign,
          label: '下单日期',
          prop: 'order_time',
          rules: [{
            required: true,
            message: '请选择下单日期',
            trigger: 'change'
          }],
          params: {
            type: 'date',
            placeholder: '请选择下单日期',
            clearable: true
          }
        },
        platform: {
          label: '投放平台',
          prop: 'platform',
          rules: [{
            required: true,
            message: '请选择投放平台',
            trigger: 'change'
          }],
          params: {
            disabled: this.isFromSS,
            options: platformList.filter(function (item) {
              // 当选择交互素材的时候，只允许选择移动平台
              var showValue = ['ios', 'android', 'ios,android'];
              if (_this.isInteractiveCreation) {
                return showValue.indexOf(item.value) !== -1;
              }
              return true;
            }),
            clearable: true,
            placeholder: '请选择投放平台'
          }
        },
        key_account: {
          visible: this.isMintegral || this.isBigMedia,
          label: '是否KA',
          prop: 'key_account',
          rules: [{
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }],
          params: {
            options: customerTypeList,
            clearable: true
          }
        },
        type: {
          label: '需求类型',
          prop: 'type',
          rules: [{
            required: true,
            message: '请选择需求类型',
            trigger: 'change'
          }],
          params: {
            disabled: this.isFromSS,
            options: typeList,
            clearable: true
          }
        },
        channel_type: {
          // 非交互素材才展示投放渠道类型，因为不同素材类型是由不同的人在做的
          visible: this.isNonInteractiveCreation,
          label: '投放渠道类型',
          prop: 'channel_type',
          rules: [{
            required: true,
            message: '请选择投放渠道类型',
            trigger: 'change'
          }],
          params: {
            options: channelTypeList
          }
        },
        is_advertiser_review: {
          // 需求类型=交互素材，显示“广告主是否审核”字段，必填，默认为空
          visible: this.isInteractiveCreation,
          label: '广告主是否审核',
          prop: 'is_advertiser_review',
          rules: [{
            required: true,
            message: '请选择广告主是否审核',
            trigger: 'change'
          }],
          params: {
            options: advertiserAuditList,
            clearable: true
          }
        },
        adv_id: {
          label: '广告主名称',
          prop: 'adv_id',
          rules: [{
            required: true,
            message: '请输入广告主名称',
            trigger: 'blur'
          }],
          params: {
            clearable: true,
            readonly: true,
            type: 'text',
            filterable: true,
            placeholder: '请输入广告主名称'
          }
        },
        content_rating: {
          // 需求类型=交互素材”&&投放渠道=巨量引擎(投放渠道可以从任意一个创意里面获取)
          visible: this.isInteractiveCreation && this.creationList.some(function (creation) {
            return creation.channel.indexOf(9) !== -1;
          }),
          label: '适龄提示',
          prop: 'content_rating',
          rules: [{
            required: true,
            message: '请选择适龄提示',
            trigger: 'change'
          }],
          params: {
            options: contentRatingList
          }
        },
        ir_report_point: {
          // 需求类型=交互素材”&&投放渠道=ironsource(投放渠道可以从任意一个创意里面获取)
          visible: this.isInteractiveCreation && this.creationList.some(function (creation) {
            return creation.channel.indexOf(10) !== -1;
          }),
          label: '是否接入IR埋点',
          prop: 'ir_report_point',
          rules: [{
            required: true,
            message: '请选择是否接入',
            trigger: 'change'
          }],
          params: {
            options: reportPointList
          }
        },
        ir_creative_genre: {
          // 需求类型=交互素材”&&投放渠道=ironsource(投放渠道可以从任意一个创意里面获取)&&选择接入埋点
          visible: this.isInteractiveCreation && this.creationList.some(function (creation) {
            return creation.channel.indexOf(10) !== -1;
          }) && this.demand.ir_report_point,
          label: '创意流派',
          prop: 'ir_creative_genre',
          rules: [{
            required: true,
            message: '请选择创意流派',
            trigger: 'change'
          }],
          params: {
            options: creativeGenreList
          }
        },
        interactive_type: {
          // 交互素材才展示创意类型，同一个需求的创意类型必须为同一种
          visible: this.isInteractiveCreation,
          label: '创意类型',
          prop: 'interactive_type',
          rules: [{
            required: true,
            message: '请选择创意类型',
            trigger: 'change'
          }],
          params: {
            disabled: this.isFromSS,
            options: this.creationTypeList
          }
        },
        similar_demand_ids: {
          label: '参考需求',
          prop: 'similar_demand_ids',
          style: 'width: 100%;',
          params: {
            style: 'width: 100%;',
            multiple: true
          }
        },
        material_source: {
          label: '素材来源',
          prop: 'material_source',
          rules: [{
            required: true,
            message: '请选择素材来源',
            trigger: 'change'
          }],
          params: {
            options: this.innerSourceList,
            clearable: true
          }
        },
        account_manager_id: {
          label: '需求AM',
          prop: 'account_manager_id',
          rules: [{
            required: true,
            message: '请输入需求AM',
            trigger: 'blur'
          }],
          params: {
            clearable: true,
            readonly: true,
            type: 'text',
            filterable: true,
            placeholder: '请输入需求AM'
          }
        },
        business_type: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '大媒体业务类型',
          prop: 'business_type',
          rules: [{
            required: true,
            message: '请选择投放大媒体业务类型',
            trigger: 'change'
          }],
          params: {
            options: businessTypeList
          }
        },
        is_new_order: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '是否新单',
          prop: 'is_new_order',
          rules: [{
            required: true,
            message: '请选择是否新单',
            trigger: 'change'
          }],
          params: {
            options: [{
              value: 1,
              label: '是'
            }, {
              value: 2,
              label: '否'
            }]
          }
        },
        project_type: {
          label: '项目类型',
          prop: 'project_type',
          rules: [{
            required: this.isNonInteractiveCreation, // 非交互素材必须填写项目类型，交互素材可以不填
            message: '请选择项目类型',
            trigger: 'change'
          }],
          params: {
            options: projectTypeList
          }
        },
        project_other: {
          visible: Number(this.demand.project_type) === 99,
          label: '其他项目类型',
          prop: 'project_other',
          rules: [{
            required: true,
            message: '请输入项目类型',
            trigger: 'blur'
          }, {
            min: 1,
            max: 200,
            message: '项目类型不能超过 200 个字符',
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入项目类型'
          }
        },
        split_num: {
          visible: this.isNoninteractiveAndBidMediaAndMTG && this.pageType !== 'update',
          label: '拆分需求个数',
          prop: 'split_num',
          params: {
            min: 1,
            max: 10,
            step: 1,
            'show-stops': true
          }
        },
        big_media_is_use_template: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '使用模板',
          prop: 'big_media_is_use_template',
          rules: [{
            required: true,
            message: '请选择是否使用模板',
            trigger: 'change'
          }],
          params: {
            options: [{
              value: 1,
              label: '是'
            }, {
              value: 2,
              label: '否'
            }]
          }
        },
        big_media_tpl_id: {
          visible: this.isNoninteractiveAndBigMedia && Number(this.demand.big_media_is_use_template) === 1,
          label: '大媒体模板ID',
          prop: 'big_media_tpl_id',
          rules: [{
            required: true,
            message: '请输入大媒体模板ID',
            trigger: 'blur'
          }, {
            min: 1,
            max: 100,
            message: '大媒体模板ID不能超过 100 个字符',
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入大媒体模板ID'
          }
        },
        big_media_creative_type: {
          visible: this.isNoninteractiveAndBigMedia && Number(this.demand.big_media_is_use_template) === 2,
          label: '大媒体创意类型',
          prop: 'big_media_creative_type',
          rules: [{
            required: true,
            message: '请选择大媒体创意类型',
            trigger: 'change'
          }],
          params: {
            options: bigMediaCreativeTypeList
          }
        },
        big_media_creative_type_other: {
          visible: this.isNoninteractiveAndBigMedia && this.demand.big_media_creative_type === '其他',
          label: '其他大媒体创意类型',
          prop: 'big_media_creative_type_other',
          rules: [{
            required: true,
            message: '请输入大媒体创意类型',
            trigger: 'blur'
          }, {
            min: 1,
            max: 100,
            message: '大媒体创意类型不能超过 100 个字符',
            trigger: 'blur'
          }, {
            validator: function validator(rule, value, callback) {
              if (['对比', '解说'].some(function (item) {
                return item === value;
              })) {
                callback(new Error('其他大媒体创意类型不可填写对比或解说'));
              }
              callback();
            },
            trigger: 'blur'
          }],
          params: {
            type: 'text',
            clearable: true,
            placeholder: '请输入大媒体创意类型'
          }
        },
        invoice_id: {
          label: 'Related invoice',
          prop: 'invoice_id',
          rules: [{
            required: this.currentAdvertiserHasInvoices,
            message: '请选择 Related invoice',
            trigger: 'blur'
          }]
        },
        grade: {
          visible: Number(this.demand.type) === 1,
          label: '分档',
          prop: 'grade',
          params: {
            options: gradeList,
            clearable: true
          }
        },
        is_pt_custom: {
          visible: this.isDesign && this.isInteractiveCreation,
          label: 'Playturbo 定制',
          prop: 'is_pt_custom',
          rules: [{
            required: true,
            message: '请选择是否是 Playturbo 定制',
            trigger: 'change'
          }],
          params: {
            options: [{
              value: 1,
              label: '是'
            }, {
              value: 2,
              label: '否'
            }],
            clearable: true
          }
        },
        is_make_dco: {
          visible: this.isDesign && this.isInteractiveCreation,
          label: '制作 DCO',
          prop: 'is_make_dco',
          rules: [{
            required: true,
            message: '请选择是否制作 DCO',
            trigger: 'change'
          }],
          params: {
            options: [{
              value: 1,
              label: '是'
            }, {
              value: 2,
              label: '否'
            }],
            clearable: true
          }
        },
        ia_material_type: {
          visible: this.isDesign && this.isInteractiveCreation,
          label: '需求素材类型',
          prop: 'ia_material_type',
          rules: [{
            required: true,
            message: '请选择需求素材类型',
            trigger: 'change'
          }],
          params: {
            options: interactiveMaterialTypeList,
            clearable: true
          }
        },
        nia_tag2_id: {
          visible: this.isDesign && this.isNonInteractiveCreation,
          label: '二级标签',
          prop: 'nia_tag2_id',
          rules: [{
            required: true,
            message: '请选择二级标签',
            trigger: 'change'
          }],
          params: {
            options: noninteractiveSecondaryLevelTagList,
            clearable: true
          }
        },
        nia_tag3_id: {
          visible: this.isDesign && this.isNonInteractiveCreation,
          label: '三级标签',
          prop: 'nia_tag3_id',
          rules: [{
            required: true,
            message: '请选择三级标签',
            trigger: 'change'
          }],
          params: {
            options: noninteractiveThirdLevelTagList,
            clearable: true
          }
        },
        case_auth_type: {
          visible: this.isDesign,
          label: '案例宣传授权',
          prop: 'case_auth_type',
          rules: [{
            required: true,
            message: '请选择案例宣传授权类型',
            trigger: 'change'
          }],
          params: {
            options: caseAuthTypeList,
            clearable: true
          }
        },
        // 选择部分授权展示授权备注
        case_remark: {
          visible: this.isDesign && this.demand.case_auth_type === 3,
          label: '案例宣传备注',
          prop: 'case_remark',
          rules: [{
            required: true,
            message: '请输入案例宣传备注',
            trigger: 'blur'
          }, {
            min: 1,
            max: 200,
            message: '案例宣传备注不能超过 200 个字符',
            trigger: 'blur'
          }],
          params: {
            type: 'textarea',
            autosize: { minRows: 2, maxRows: 10 },
            clearable: true
          }
        },

        service_attribution: {
          visible: this.isDesign && this.isInteractiveCreation,
          label: '服务归属',
          prop: 'service_attribution',
          rules: [{
            required: true,
            message: '请选择服务归属',
            trigger: 'change'
          }],
          params: {
            options: serviceAttribution,
            clearable: true
          }
        },

        service_type: {
          visible: this.isDesign && this.isInteractiveCreation && this.demand.service_attribution,
          label: '服务类型',
          prop: 'service_type',
          rules: [{
            required: true,
            message: '请选择服务类型',
            trigger: 'change'
          }],
          params: {
            /* eslint-disable indent */
            options: this.demand.service_attribution ? serviceType[serviceAttribution.find(function (item) {
              return item.value === _this.demand.service_attribution;
            }).prop] : [],
            clearable: true
          }
        },

        biz_scenario: {
          label: '业务场景',
          prop: 'biz_scenario',
          rules: [{
            required: true,
            message: '请选择业务场景',
            trigger: 'change'
          }],
          params: {
            options: bizScenario.filter(function (item) {
              if (_this.isDesign) {
                return [1, 3, 6].includes(item.value);
              } else if (_this.isFromSS) {
                return [4].includes(item.value);
              }
              return [2, 5].includes(item.value);
            })
          }
        }

      }, this.settlementFormItem);
    },
    innerSourceList: function innerSourceList() {
      var newList = _.clone(sourceList);
      if (this.review_id || this.isFromSS) {
        newList.splice(0, 2);
        return newList;
      }
      // 删除最后一项ss 提供
      newList.pop();
      return newList;
    },
    creationTypeList: function creationTypeList() {
      // 需求类型=交互素材：创意类型可选项包括“playable/动态endcard”，单选
      if (this.isInteractiveCreation) {
        return _.cloneDeep(interactiveCreationTypeList);
      }

      // “需求类型=非交互素材”：“需求类型”可选项包括“视频设计、视频修改、图片设计、图片修改、GIF”，单选
      if (this.isNonInteractiveCreation) {
        return _.cloneDeep(nonInteractiveCreationTypeList);
      }

      return [];
    },
    currentAdvertiser: function currentAdvertiser() {
      var _this2 = this;

      if (this.advertiserList && this.demand.adv_id) {
        return this.advertiserList.find(function (item) {
          return _this2.demand.adv_id === item.id;
        });
      }
      return null;
    }
  },

  watch: {
    // 切换平台时，更新产品信息列表
    'demand.platform': function demandPlatform(platform) {
      if (!platform) return;

      if (platform === 'ios,android') {
        var products = [_extends({}, generateProduct(), {
          platform: 'ios',
          title: 'iOS产品信息'
        }), _extends({}, generateProduct(), {
          platform: 'android',
          title: 'Android产品信息'
        })];
        this.updateProducts(products);
      } else {
        var _products = [_extends({}, generateProduct(), {
          platform: platform
        })];
        this.updateProducts(_products);
      }
    },
    'demand.service_attribution': function demandService_attribution(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.demand.service_type = '';
      }
    },
    'demand.type': function demandType(val) {
      // 避免用户选择非交互的时候勾选小程序的选项，转成交互的时候被提交
      var unworkValue = ['website', 'mini_program'];
      if (val === 1 && unworkValue.indexOf(this.demand.platform) !== -1) {
        this.demand.platform = 'ios';
      }
      this.resetCreationForm();
    },
    'demand.channel_type': function demandChannel_type(val) {
      if (val) {
        this.resetCreationForm();
      }
    },


    // 监听 formItemList，当某个表单项被隐藏时，就将其值重置为空，除了通用的，其它逻辑不要在这里监听
    formItemList: {
      handler: function handler(newFormItemList) {
        // 函数防抖，在 update 与 copy 需求的时候，会出现 form-item 的 visible 被连续变更（在很短的时间内从可见 -> 不可见 -> 可见），导致数据不对的情况，如 Application ID 被错误清空
        this.debounceUpdateDemandByFormItemToggleVisible(newFormItemList);
      },

      deep: true
    },

    'demand.category': function demandCategory() {
      // 选择设计项目默认选中付费
      this.demand.is_pay = this.isDesign ? 1 : 2;
      this.demand.order_time = this.isDesign && Date.now();
      if (this.isDesign) {
        this.demand.biz_scenario = '';
      }
    },
    'demand.case_auth_type': function demandCase_auth_type(val) {
      if (val === 3) {
        if (this.currentAdvertiser) {
          this.demand.case_remark = this.currentAdvertiser.remark;
        }
      }
    }
  },

  created: function created() {
    this.debounceUpdateDemandByFormItemToggleVisible = _.debounce(this.updateDemandByFormItemToggleVisible, 100);
    this.getAdvertiserList();
  },


  methods: {
    updateDemandByFormItemToggleVisible: function updateDemandByFormItemToggleVisible(newFormItemList) {
      var _this3 = this;

      _.each(newFormItemList, function (formItem, key) {
        if (formItem.visible === false) {
          // 针对 split_num 属性下毒，因为 slider 组件只接受 number / array 类型，如果返回空字符串，会导致报错
          if (formItem.prop === 'split_num') {
            _this3.demand[formItem.prop] = 1;
          } else if (_.isArray(_this3.demand[formItem.prop])) {
            _this3.demand[formItem.prop] = [];
          } else {
            _this3.demand[formItem.prop] = '';
          }
        }
      });
    },
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var path = _ref.path,
          name = _ref.name;

      this.demand.reference_url = path;
      this.demand.reference_name = name;
      // 更新验证状态
      this.$refs['demand-form'].validateField('reference_url');
    },


    /**
     * 重置创意要求表单
     */
    resetCreationForm: function resetCreationForm() {
      this.$refs['creation-list'].$refs.creation.forEach(function (item) {
        item.$refs.form.resetFields();
        item.$refs.form.clearValidate();
      });
      this.emptyCreationList();
    },
    updateProduct: function updateProduct(index, product) {
      var products = _.cloneDeep(this.products);
      products[index] = product;
      this.updateProducts(products);
    },


    /**
     * 验证表单
     */
    validate: function validate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var validateList, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validateList = [_this4.$refs['demand-form'].validate()];


                if (_.get(_this4, '$refs.product-info')) {
                  _this4.$refs['product-info'].forEach(function (item) {
                    validateList.push(item.$refs.form.validate());
                  });
                }

                if (_.get(_this4, '$refs.creation-list.$refs.creation')) {
                  _this4.$refs['creation-list'].$refs.creation.forEach(function (item) {
                    validateList.push(item.$refs.form.validate());
                  });
                }

                _context.prev = 3;
                _context.next = 6;
                return _Promise.all(validateList);

              case 6:
                res = _context.sent;

                console.log('验证通过');

                if (!res.every(function (item) {
                  return item === true;
                })) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', true);

              case 10:
                return _context.abrupt('return', false);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                console.log('验证不通过');
                return _context.abrupt('return', false);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[3, 13]]);
      }))();
    },
    setAdvertiserSelectorOptions: function setAdvertiserSelectorOptions(options) {
      this.$refs['advertiser-selector'].setOptions(options);
    },
    setDemandSelectorOptions: function setDemandSelectorOptions(options) {
      this.$refs['demand-selector'].setOptions(options);
    },
    openCreateAdvertiserDialog: function openCreateAdvertiserDialog() {
      this.$store.dispatch('advertiser/openDialog');
    },
    handleAdvertiserChange: function handleAdvertiserChange(val) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var currentAdvertiser;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentAdvertiser = _this5.advertiserList.find(function (item) {
                  return val === item.id;
                });

                if (_this5.isDesign && _this5.isPay) {
                  if (currentAdvertiser) {
                    _this5.demand.currency = currentAdvertiser.currency;
                    _this5.demand.is_prepaid = currentAdvertiser.advance;
                  }
                }
                if (_this5.demand.case_auth_type === 3 && _this5.isDesign) {
                  if (currentAdvertiser) {
                    _this5.demand.case_remark = currentAdvertiser.remark;
                  }
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    handleInvoiceChange: function handleInvoiceChange(invoice) {
      if (!_.isEmpty(invoice)) {
        this.demand.invoice_id = invoice.id;
        this.currentAdvertiserHasInvoices = true;
      } else {
        this.currentAdvertiserHasInvoices = false;
      }
    },
    getAdvertiserList: function getAdvertiserList() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fellAllAdvertisers();

              case 2:
                res = _context3.sent;

                _this6.advertiserList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    }
  }
};